import axios from 'axios';

const FETCH_PACKAGE = 'FETCH_PACKAGE';
const FETCH_ERROR_PACKAGE = 'FETCH_ERROR_PACKAGE';
const SET_REDIRECT_URL = 'SET_REDIRECT_URL';
const SET_INITIAL_SELECTED_CONFIGURATION = 'SET_INITIAL_SELECTED_CONFIGURATION';
const SET_CONFIGURATION_IMAGE_URL = 'SET_CONFIGURATION_IMAGE_URL';

const IMAGE_BASE_URL = 'https://trek.scene7.com/is/image/TrekBicycle/';
const IMAGE_WIDTH = 1920;

const projectOne = {
  namespaced: true,
  state: {
    redirectUrl: '',
    package: {
      data: {},
      error: null,
    },
    selectedConfiguration: {
      advertisedPrice: '',
      defaultGruppo: '',
      defaultImageLayers: [],
      id: '',
      modelName: '',
      modelPlatform: '',
      msrp: '',
    },
    configurationImageUrl: '',
  },
  getters: {
    package: (state) => state.package.data,
    platform: (state) => state.package.data.platform,
    redirectUrl: (state) => state.redirectUrl,
    defaultImageLayers: (state) => state.selectedConfiguration.defaultImageLayers,
    configurationImageUrl: (state) => state.configurationImageUrl,
  },
  mutations: {
    [FETCH_PACKAGE](state, payload) {
      state.package.data = payload;
      state.package.error = null;
    },
    [FETCH_ERROR_PACKAGE](state, payload) {
      state.package.data = null;
      state.package.error = payload;
    },
    [SET_REDIRECT_URL](state, payload) {
      state.redirectUrl = payload;
    },
    [SET_CONFIGURATION_IMAGE_URL](state, payload) {
      state.configurationImageUrl = payload;
    },
    [SET_INITIAL_SELECTED_CONFIGURATION](state, payload) {
      state.selectedConfiguration = {...payload};
    },
  },
  actions: {
    setRedirectUrl({commit}, payload) {
      commit(SET_REDIRECT_URL, payload);
    },
    updateConfigurationImageUrl({commit, getters}) {
      // Gets the image layers from the selected configuration
      const imageLayers = getters.defaultImageLayers;

      // Build URL from Image Layers
      if (imageLayers) {
        let urlParams = `wid=${IMAGE_WIDTH}`;

        imageLayers.forEach((imageLayer) => {
          urlParams += `&layer=${imageLayer.order}&src=${imageLayer.imageReference}`;
        });

        commit(SET_CONFIGURATION_IMAGE_URL, `${IMAGE_BASE_URL}?${urlParams}`);
      }
    },
    async fetchPackage({commit, dispatch, state}, payload) {
      if (payload) {
        try {
          const response = await axios.get(`/project-one/api/packages/${payload}`);
          console.log('packages API response data: ' + JSON.stringify(response.data.data, null, 1)); //TODO: Remove before P1 launch
          if (response.status === 200) {
            commit(FETCH_PACKAGE, response.data.data);
            const initialConfiguration = response.data.data.packages[0] ? response.data.data.packages[0] : {};
            commit(SET_INITIAL_SELECTED_CONFIGURATION, initialConfiguration);
            dispatch('updateConfigurationImageUrl'); // Initialize image url
            return response.status;
          } else {
            /* handle invalid packageId case */
            commit(FETCH_ERROR_PACKAGE, response);
            window.location.href = state.redirectUrl;
            return response.status;
          }
        } catch (error) {
          commit(FETCH_ERROR_PACKAGE, error);
          window.location.href = state.redirectUrl;
          return error;
        }
      } else {
        // if packageId is missing redirect
        window.location.href = state.redirectUrl;
      }
    },
  },
};

export default projectOne;
